import { Card, Collapse } from "antd";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { Oval } from "react-loader-spinner";

import axios from "axios";
import { api } from "../../api/url";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import "./style.css";

const makeRule = (begin, end, percent) => {
  if (begin === 0 && end !== 0) {
    return {
      title: `لغو نوبت تا ${end} ساعت قبل`,
      description: `در صورت کنسلی نوبت تا قبل از ${end} ساعت معادل ${100 - percent}  وجه نوبت عودت خواهد شد.`,
    };
  } else if (end === 0 && begin !== 0)
    return {
      title: `لغو نوبت از ${begin} ساعت قبل`,
      description: `و در صورت کنسلی نوبت در ${begin} ساعت پایانی نوبت، هیچ وجهی به حساب شما عودت نخواهد شد.`,
    };
  else
    return {
      title: `لغو نوبت تا ${end} ساعت قبل`,
      description: `در صورت کنسلی نوبت از ${begin} تا ${end} ساعت معادل ${percent} درصد وجه نوبت از حساب شما کسر خواهد شد.`,
    };
};

const CanselRulesPage = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [cmpName, setCmpName] = useState();
  const [loading, setLoading] = useState(true);

  const GetRules = async () => {
    await axios({
      method: "get",
      url: api + "appointment/penalty/getlist/" + id,
    })
      .then((res) => {
        setCmpName(res.data.data.companyName);
        let arr = res?.data?.data?.penaltyList?.map((item) =>
          makeRule(item.beginDuration, item.endDuration, item.penaltyValue)
        );
        setData(arr);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    GetRules();
  }, []);

  return (
    <div className="aboutus-container">
      <Card className="cancelrules-card">
        {loading ? (
          <div className="loading-container">
            <Oval
              visible={true}
              height="35"
              width="35"
              strokeWidth={3}
              color="#1E2B3B"
              ariaLabel="oval-loading"
              secondaryColor="#ACADAD"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : (
          <>
            <h5>قوانین لغو نوبت برای {cmpName}</h5>
            <div className="cancelrules-container">
              {data.map((item, index) => (
                <Collapse
                  defaultActiveKey={"collapse0"}
                  className={"rules-card-collaps-header "}
                  expandIcon={({ isActive }) =>
                    isActive ? <FiChevronUp /> : <FiChevronDown />
                  }
                  style={{ marginBottom: 8 }}
                  expandIconPosition="right"
                  items={[
                    {
                      key: String("collapse" + index),
                      label: item.title,

                      children: <RulesContent item={item.description} />,
                    },
                  ]}
                />
              ))}
            </div>
          </>
        )}
      </Card>
    </div>
  );
};

export default CanselRulesPage;

const RulesContent = (props) => {
  return (
    <div>
      <p>{props.item}</p>
    </div>
  );
};
